import { combineReducers } from 'redux';

import signUpReducer from './signUp';
import signInReducer from './signIn';

export const AUTHORIZATION_STATE_KEY = 'auth';

export default combineReducers({
  signUp: signUpReducer,
  signIn: signInReducer,
});
